import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/scrollbar';

export default class DataTableSwiper {
  static init() {
    document.querySelectorAll('.data-table__wrapper[data-data-table]').forEach((wrapper) => {
      let resizeFrame;
      const update = () => {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => this.update(wrapper));
      };

      this.update(wrapper);

      // Tables can become wider or narrower when the viewport changes. Keep
      // the interaction in sync rather than showing a scrollbar unnecessarily.
      const resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(wrapper);
      resizeObserver.observe(wrapper.querySelector('.data-table__inner'));
      window.addEventListener('resize', update, { passive: true });
      window.addEventListener('orientationchange', update, { passive: true });
    });
  }

  static update(wrapper) {
    const inner = wrapper.querySelector('.data-table__inner');
    if (!inner) return;

    const needsScrolling = this.needsScrolling(wrapper, inner);
    const isStatic = wrapper.classList.contains('data-table__wrapper--static');

    if (needsScrolling && isStatic) {
      wrapper.classList.remove('data-table__wrapper--static');
      this.enableSwiper(wrapper);
    } else if (!needsScrolling && !isStatic) {
      this.disableSwiper(wrapper);
      wrapper.classList.add('data-table__wrapper--static');
    } else if (needsScrolling && !wrapper.classList.contains('swiper-initialized')) {
      this.enableSwiper(wrapper);
    }
  }

  static needsScrolling(wrapper, inner) {
    // Measure the table at its natural width, not at the wrapper's minimum
    // width. This lets compact tables remain static and centered.
    wrapper.classList.add('data-table__wrapper--measuring');
    // `getBoundingClientRect()` reports the flex-shrunk width of a centered
    // table. `scrollWidth` retains its actual content width, so a table that
    // no longer fits after a viewport resize correctly switches to Swiper.
    const needsScrolling = inner.scrollWidth > wrapper.clientWidth + 1;
    wrapper.classList.remove('data-table__wrapper--measuring');

    return needsScrolling;
  }

  static enableSwiper(wrapper) {
    if (wrapper.classList.contains('swiper-initialized')) return;

    const slidesContainer = wrapper.querySelector('.data-table__slides');
    const scrollbarEl = wrapper.querySelector('.swiper-scrollbar');
    const inner = wrapper.querySelector('.data-table__inner');
    if (!slidesContainer || !scrollbarEl || !inner) return;

    const slide = document.createElement('div');
    slide.className = 'swiper-slide';
    slide.appendChild(inner);

    slidesContainer.replaceChildren(slide);

    new Swiper(wrapper, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: {
        enabled: true,
        sticky: false,
        momentum: false,
      },
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        snapOnRelease: false,
      },
      // A data table is one wide slide. Locking a one-slide Swiper resets
      // the scrollbar to its start position after a drag.
      watchOverflow: false,
    });

    wrapper.classList.add('swiper-initialized');
  }

  static disableSwiper(wrapper) {
    const swiper = wrapper.swiper;
    const slidesContainer = wrapper.querySelector('.data-table__slides');
    const inner = wrapper.querySelector('.data-table__inner');
    if (!slidesContainer || !inner) return;

    if (swiper) swiper.destroy(true, true);

    wrapper.insertBefore(inner, slidesContainer);
    slidesContainer.replaceChildren();
    wrapper.classList.remove('swiper-initialized');
  }
}
